var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lDfault',{attrs:{"title":"个人教材信息"}},[_vm._v(" 个人教材信息 ")])}
var staticRenderFns = []

export { render, staticRenderFns }